import { Field, getFormValues } from 'redux-form';
import { Form, Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import { CREATE_EDIT_TRANSFER_FORM_NAME } from 'Common/FormEnum';
import { GridEnum } from 'Common/Constants/Enumeration/GridEnum';
import { CreateEditTransferEnum } from 'Common/FieldEnum';
import { InputField } from 'Common/SemanticWrapper';
import { ItemGridFormField } from 'Components';

class PreviewTransferComponent extends Component {
  render() {
    const {
      fromSite,
      transferItemsInfo,
      resetPageOnDataChange,
      onResetPageOnDataChange,
    } = this.props;

    return (
      <Form>
        <Grid>
          <Grid.Row>
            <Grid.Column width={3}>
              <Field
                name={CreateEditTransferEnum.Comments}
                component={InputField}
                type="text"
                maxLength={50}
                label={'Comments'}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={4}>
              <label className={'text-orange'}>
                Available Items at Site {fromSite}
              </label>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <hr />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column>
              <Field
                component={ItemGridFormField}
                name={CreateEditTransferEnum.TransferItemsInfo}
                {...{
                  dataSource: transferItemsInfo,
                  isPreviewPage: true,
                  gridName: GridEnum.INV_TransferOrder_CreateEdit_View,
                  tableName: TableNamesEnum.TRANSFER_ITEM_TABLE,
                  onResetPageOnDataChange: onResetPageOnDataChange,
                  resetPageOnDataChange: resetPageOnDataChange,
                }}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Form>
    );
  }
}

PreviewTransferComponent.propTypes = {
  transferItemsInfo: PropTypes.array,
  resetPageOnDataChange: PropTypes.bool,
  onResetPageOnDataChange: PropTypes.func,
};

PreviewTransferComponent.defaultProps = {
  transferItemsInfo: [],
  resetPageOnDataChange: true,
  onResetPageOnDataChange: () => {},
};

const mapStateToProps = state => {
  const formValues = getFormValues(CREATE_EDIT_TRANSFER_FORM_NAME)(state);
  return {
    fromSite: formValues.FromSite,
  };
};

const mapDispatchToProps = {};

export const PreviewTransferComponentForm = connect(
  mapStateToProps,
  mapDispatchToProps
)(PreviewTransferComponent);



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/transfer/components/createEditTransfer/PreviewTransfer.js